import { render, staticRenderFns } from "./task_detail_dialog.vue?vue&type=template&id=5300b046"
import script from "./task_detail_dialog.vue?vue&type=script&lang=js"
export * from "./task_detail_dialog.vue?vue&type=script&lang=js"
import style0 from "./task_detail_dialog.vue?vue&type=style&index=0&id=5300b046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports